import { render, staticRenderFns } from "./treatment.vue?vue&type=template&id=4beeb869&scoped=true&"
import script from "./treatment.vue?vue&type=script&lang=js&"
export * from "./treatment.vue?vue&type=script&lang=js&"
import style0 from "./treatment.vue?vue&type=style&index=0&id=4beeb869&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4beeb869",
  null
  
)

export default component.exports